/*
Wspólna logika wyszukiwania utworów (modal dodawania + pole SearchOption),
żeby obie wyszukiwarki dopasowywały tak samo.
*/

// Myślnik w "Wykonawca - Tytuł" to tylko separator, więc traktujemy go jak spację
// — dzięki temu "oasis wonderwall" znajduje "Oasis - Wonderwall" bez wpisywania myślnika.
export const normalizeSongText = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/[`'''""".,:;!?]/g, "") // usuń większość interpunkcji
    .replace(/[-_/]+/g, " ")         // separatory jak spacja
    .replace(/\s+/g, " ")            // wiele spacji na jedną
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // usuń znaki diakrytyczne
    .replace(/ł/g, "l"); // NFD nie rozkłada "ł", więc osobno — "malomiasteczkowy" ma trafiać

// Wpisana fraza rozbita na słowa. Utwór pasuje, gdy zawiera je wszystkie,
// więc kolejność nie ma znaczenia ("wonderwall oasis" też trafia).
export const songQueryTokens = (query) =>
  normalizeSongText(query).split(" ").filter(Boolean);

export const matchesSongQuery = (normalizedSong, tokens) =>
  tokens.every((token) => normalizedSong.includes(token));

// Im mniejsza wartość, tym lepsze dopasowanie: najpierw utwory zaczynające się
// od wpisanej frazy, potem zawierające ją w całości (im wcześniej, tym wyżej),
// na końcu trafienia po samych słowach — np. wpisane w innej kolejności.
export const songMatchRank = (normalizedSong, normalizedQuery) => {
  if (normalizedSong.startsWith(normalizedQuery)) return -1;

  const index = normalizedSong.indexOf(normalizedQuery);

  return index >= 0 ? index : Number.MAX_SAFE_INTEGER;
};
